const mutations = {
  getRegistrationButton: (state, registration_button) => {
    state.registration_button = registration_button;
  },
  postRegistrationButton: (state, new_registration_button) => {
    state.registration_button = new_registration_button;
  },
};

export default mutations;
